import React, { Component } from "react";
import * as R from "ramda";
import FlexView from "react-flexview";
import { configYearToDate, yearOptions, transformResponseYearsToDateToTable } from "../config";
import { removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class YearToDateSalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configYearToDate(),
        }));
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (!R.equals(prevProps.search, this.props.search)) {
    //         this.fetchData();
    //     }
    // };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            const request = removeNullFields({
                kodeCabang: this.props.search,
                year: this.state.year?.value,
                employeeIdTeamLeader: this.props.idLeader,
                employeeIdSales: null
            });

            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanYTDMetodePembayaranDanLeasing,
                setError: this.props.setError,
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Jualan Year To Date",
                args: request,
            });
            
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: transformResponseYearsToDateToTable(res.data.data),
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("errors: ", error);
        }
    };

    handleSearch = () => {
      this.setState(
        (prev) => ({
          ...prev,
          tableConfig: configYearToDate(prev.year?.value),
        }),
        () => this.fetchData(),
      );
    };

    render() {
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        isClearable
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, { name }) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                />
            </>
        );
    };
}

export default YearToDateSalesReport;